import React from "react";
import { Sparkles } from "lucide-react";

export const FloatingSignUp = () => {
  const handleClick = (e) => {
    e.preventDefault();
    const target = document.getElementById("signup");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = "/#signup";
    }
  };

  return (
    <a
      href="#signup"
      onClick={handleClick}
      aria-label="Sign up"
      data-testid="floating-signup-btn"
      className="fixed bottom-32 right-6 z-50 flex items-center gap-2 bg-[#16C79A] hover:bg-[#0C2D48] text-[#0C2D48] hover:text-white rounded-full pl-4 pr-5 py-3 shadow-lg shadow-[#16C79A]/30 hover:shadow-xl hover:shadow-[#16C79A]/40 hover:-translate-y-0.5 font-bold"
      style={{ transition: "background-color 0.3s, color 0.3s, box-shadow 0.3s, transform 0.3s" }}
    >
      <Sparkles size={20} className="flex-shrink-0" />
      <span className="text-sm hidden sm:inline">Sign up</span>
    </a>
  );
};
